import styled from 'styled-components'

const UL = styled.ul`
  margin: 0;
  padding: 0;
  list-style-position: inside;
`

export default UL
